import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import {
  BackgroundColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Easings } from '@picsart/design-system/foundation/easings';
import { canHover } from '@picsart/design-system/styleUtils/hoverTouch';
import { textOverflowHidden } from '@/utils/styles/dsStyleHelpers';

const THUMBNAIL_SIZE = Spacings.s48;

const useStyles = createUseStyles(
  {
    row: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      width: '100%',
      padding: [Spacings.s8, Spacings.s12],
      border: 'none',
      borderRadius: CornerRadius.r12,
      backgroundColor: 'transparent',
      color: TextColors.base,
      textAlign: 'start',
      cursor: 'pointer',
      transition: `background-color 0.15s ${Easings.easeOut}`,
      [canHover]: {
        '&:hover': {
          backgroundColor: BackgroundColors.tint2,
        },
      },
      '&:disabled': {
        cursor: 'default',
      },
    },
    thumbnail: {
      width: THUMBNAIL_SIZE,
      height: THUMBNAIL_SIZE,
      flex: `0 0 ${THUMBNAIL_SIZE}`,
      borderRadius: CornerRadius.r8,
      objectFit: 'cover',
      backgroundColor: BackgroundColors.tint2,
    },
    text: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s2,
      minWidth: 0,
    },
    title: {
      fontSize: FontSizes.t5,
      lineHeight: `${LineHeights.t5}px`,
      fontWeight: FontWeights.medium,
      color: TextColors.base,
      ...textOverflowHidden,
    },
    category: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s4,
      fontSize: FontSizes.t4,
      lineHeight: `${LineHeights.t4}px`,
      color: TextColors.tint2,
      ...textOverflowHidden,
    },
    typeIcon: {
      width: Spacings.s16,
      height: Spacings.s16,
      flexShrink: 0,
    },
  },
  { name: 'search-suggestion-row' }
);

export default useStyles;
